import { Box, Button, Grid, IconButton, Switch } from "@mui/material";
import CustomInput from "../components/ui/CustomInput";
import CustomRadioButton from "../components/ui/CustomRadioButton";
import PageHeader from "../components/ui/PageHeader";
import PageForm from "../components/ui/PageForm";
import BarcodeIcon from "../components/ui/BarcodeIcon";
import CustomGridCell from "../components/ui/CustomGridCell";
import CustomGridHeaderCell from "../components/ui/CustomGridHeaderCell";
import { useRef, useState, useEffect, useCallback } from "react";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CustomTable from "../components/ui/CustomTable";
import axios from "../api/axiosClient";
import CustomTablePagingInfo from "../components/ui/CustomTablePagingInfo";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import { useLoading } from "../components/LoadingContext";
import { useSelector } from "react-redux";
import { handleError, errorToast, useKeyDown, combineStrings } from "../services/serviceBase";
import toast from "react-hot-toast";
import CustomTriStateCheckbox from "../components/ui/CustomTriSateCheckbox";
import { setSearch } from "../redux/searchSlice";
import { setFromDateFilter } from "../redux/searchSlice";
import { setToDateFilter } from "../redux/searchSlice";
import { setDoSearch } from "../redux/searchSlice";
import { useDispatch } from "react-redux";
import { setBoxBarcode } from "../redux/qcSlice";
import * as apiService from "../services/apiService";

const RASearch = () => {
  const intl = useIntl();
  const idCompany = useSelector((state) => state.common.company);
  const user = useSelector((state) => state.auth.user);
  const withStealthFlow = useSelector((state) => state.common.withStealthFlow);
  const searchFilterSlice = useSelector((state) => state.search.searchFilters);
  const fromDateFilterSlice = useSelector((state) => state.search.fromDateFilter);
  const toDateFilterSlice = useSelector((state) => state.search.toDateFilter);
  const doSearch = useSelector((state) => state.search.doSearch);
  const customerCode = useSelector((state) => state.actas.customerCode);
  const { setLoading } = useLoading();
  const dispatch = useDispatch();

  const isCSVIUser = user?.profile?.default_role == "CSV-I";

  const [returnAuthorizationKey, setReturnAuthorizationKey] = useState("");
  const [cartonBarcode, setCartonBarcode] = useState("");
  const [year, setYear] = useState("");
  const [raDepartment, setRaDepartment] = useState({ text: "", value: "" });
  const [raNumber, setRaNumber] = useState("");
  const [raSplit, setRaSplit] = useState("");
  const [type, setType] = useState("");
  const [state, setState] = useState({ text: "", value: "" });
  const [sku, setSKU] = useState("");
  const [cartonQC, setCartonQC] = useState("");

  const [jdaIct, setJdaIct] = useState("");
  const [outcome, setOutcome] = useState("");
  const [invoice, setInvoice] = useState("");
  const [sapInboundDelivery, setSapInboundDelivery] = useState("");
  const [sapRso, setSapRso] = useState("");
  const [sapClient, setSapClient] = useState("");
  const [stealthClient, setStealthClient] = useState("");
  const [sapOutboundDelivery, setSapOutboundDelivery] = useState("");
  const [clientDescription, setClientDescription] = useState("");
  const [shopCode, setShopCode] = useState("");
  const [jdaLocation, setJdaLocation] = useState("");
  const [purchaseOrder, setPurchaseOrder] = useState("");
  const [country, setCountry] = useState({ text: "", value: null });
  
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  const [shouldFilterCollapse, setShouldFilterCollapse] = useState(false);

  const [countries, setCountries] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [types, setTypes] = useState([]);
  const [states, setStates] = useState([]);

  const [includeDeleted, setIncludeDeleted] = useState(false);

  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [columns, setColumns] = useState([]);

  const [dossierAge, setDossierAge] = useState("");
  const [checkRadioRed, setCheckRadioRed] = useState(false);
  const [checkRadioOrange, setCheckRadioOrange] = useState(false);
  const [checkRadioWhite, setCheckRadioWhite] = useState(false);

  const [isUrgent, setIsUrgent] = useState(null);

  const [rowHeight, setRowHeight] = useState(65);
  const [tableHeigth, setTableHeigth] = useState(20);
  const [headerHeight, setHeaderHeight] = useState(80);
  const [rowsToDisplay, setRowsToDisplay] = useState(3);

  const handleRowsToDisplay = (n) => {
    const baseHeight = 65;
    let newHeight;

    if (n === 1) {
      newHeight = baseHeight / 3;
    } else if (n === 2) {
      newHeight = (2 * baseHeight) / 3;
    } else if (n === 3) {
      newHeight = baseHeight;
    }

    setRowHeight(newHeight);
    setRowsToDisplay(n);
  };

  useEffect(() => {
    getColumns();
  }, [rowsToDisplay]);

  const handleRadioReset = () => {
    setCheckRadioRed(false);
    setCheckRadioOrange(false);
    setCheckRadioWhite(false);
    setDossierAge("");
  };

  const handleCheckRadioRed = () => {
    if (!checkRadioRed) {
      setCheckRadioRed(true);
      setCheckRadioOrange(false);
      setCheckRadioWhite(false);
      setDossierAge("Red");
    } else {
      setCheckRadioRed(false);
      setDossierAge("");
    }
  };

  const handleCheckRadioOrange = () => {
    if (!checkRadioOrange) {
      setCheckRadioOrange(true);
      setCheckRadioRed(false);
      setCheckRadioWhite(false);
      setDossierAge("Orange");
    } else {
      setCheckRadioOrange(false);
      setDossierAge("");
    }
  };

  const handleCheckRadioWhite = () => {
    if (!checkRadioWhite) {
      setCheckRadioWhite(true);
      setCheckRadioRed(false);
      setCheckRadioOrange(false);
      setDossierAge("Blue");
    } else {
      setCheckRadioWhite(false);
      setDossierAge("");
    }
  };

  const handleDatesValidation = () => {
    if (fromDate != null && toDate != null && fromDate > toDate) {
      setFromDate(null);
      setToDate(null);
      toast.error(
        intl.formatMessage({ id: "Error.StartDateLaterThenEndDate" })
      );
    } else if (fromDate != null) {
      setFromDate(fromDate);
    } else if (toDate != null) {
      setToDate(toDate);
    }
  };

  useEffect(() => {
    handleDatesValidation();
  }, [fromDate, toDate]);

  const prevCompany = useRef(null);
  const page = useRef(0);
  const maxPage = useRef(0);
  const rowsForPage = 10;

  const actAsCustomerCode = useSelector((state) => state.actas.customerCode);

  useKeyDown(() => {
    handleSearch();
  }, ["Enter"]);

  const resizeTable = () => {
    var fromHeight = document.querySelector("#form").clientHeight;
    var headerHeight = document.querySelector("#header").clientHeight;
    var pagingInfoHeight = document.querySelector("#pagingInfo").clientHeight;
    var pageHeight = window.innerHeight;
    var tableHeight =
      pageHeight - fromHeight - headerHeight - pagingInfoHeight - 90;
    setTableHeigth(tableHeight);
  };

  useEffect(() => {
    window.addEventListener("resize", resizeTable);
    return () => {
      window.removeEventListener("resize", resizeTable);
    };
  }, []);

  useEffect(() => {
    getColumns();
  }, [rows, page, tableHeigth, idCompany]);

  useEffect(() => {
    setRows([]);
    // reset filters only on an actual brand change, not on mount
    // (on mount the filters may be restored from the search slice)
    if (prevCompany.current !== idCompany) {
      if (prevCompany.current !== null) handleReset();
      prevCompany.current = idCompany;
    }
  }, [idCompany]);

  useEffect(() => {
      if(withStealthFlow){
        setStealthClient(actAsCustomerCode);
      }
      else{
        setSapClient(actAsCustomerCode);
      }
  }, [actAsCustomerCode, withStealthFlow]);

  const getColumns = () => {
    let columnColor = withStealthFlow ? "#7f7f7f" : "white"
    setColumns([
      {
        field: "actions",
        type: "actions",
        headerClassName: "grid-header apeLigthBlueBackground",
        headerName: "",
        width: 80,
        resizable: false,
        renderCell: (params) => {
          let url = "/RADetail/" + params.row.idReturnFileHead;
          if(params.row.rfStateCode == "CheckInAtWarehouse" && !isCSVIUser){
            url = "/QCDetail/" + params.row.idReturnFileHead;
          }
          else if(params.row.rfStateCode == "Preparing" || params.row.rfStateCode == "Initial"){
            url = "/RAPreparing/" + params.row.idReturnFileHead;
          }
          return (
            <Link to={url}>
              <IconButton aria-label="go" size="large" color="primary">
                <ArrowForwardIosIcon />
              </IconButton>
            </Link>
          );
        },
      },
      {
        field: "dossierAge",
        headerClassName: "apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RASearch.Dossier" })}
            item2={intl.formatMessage({ id: "RASearch.Age" })}
            item3={intl.formatMessage({ id: "RASearch.Days" })}
            rowsToDisplay={rowsToDisplay}
          />
        ),
        width: 100,
        resizable: false,
        renderCell: (params) => {
          let color = "";
          if (params.row.dossierAge == null) {
            color = "";
          } else if (params.row.dossierAge >= 5) {
            color = "#e53935";
          } else if (params.row.dossierAge == 3 || params.row.dossierAge == 4) {
            color = "#fb8c00";
          } else if (params.row.dossierAge >= 0 && params.row.dossierAge <= 2) {
            color = "#80deea";
          }
          return (
            <CustomGridCell
              item1={params.row.dossierAge >= 0 ? params.row.dossierAge : ""}
              backgroundColor={color}
              width="100%"
              heigth="100%"
              display="flex"
              alignItems="center"
              color="white !important"
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "returnFileKey",
        headerClassName: "grid-header apeLigthBlueBackground",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RA.Key" })}
            item2={intl.formatMessage({ id: "RA.State" })}
            item3={combineStrings([intl.formatMessage({ id: "RA.ReconditioningType" }), intl.formatMessage({ id: "RA.QCOutcome" })], "/")
            } 
            rowsToDisplay={rowsToDisplay}
          />
        ),
        flex: 1,
        minWidth: 250,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.returnFileKey}
              item2={params.row.rfStateDescr}
              item3={combineStrings([params.row.reconditionTypeDescr, params.row.qcOutcome], "/")}
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "ictReference",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RASearch.BoxQty" })}
            item2={intl.formatMessage({ id: "RA.Invoice" }) + "/" + intl.formatMessage({ id: "RASearch.JDAICT" })}
            item3={intl.formatMessage({ id: "RASearch.Category" })}
            rowsToDisplay={rowsToDisplay}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={combineStrings([params.row.boxInCount, params.row.itemsCount],"/")}
              item2={combineStrings([params.row.invoiceNumber, params.row.ictReference], "/")}
              item3={params.row.category}
              isHighlight={params.row.highlightCategory}
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "sapInboundDelivery",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RA.SapInboundDelivery" })}
            item1Color={columnColor}
            item2={intl.formatMessage({ id: "RASearch.SAPRSO_OD" })}
            item3={intl.formatMessage({ id: "RASearch.IsUrgent" }) }
            rowsToDisplay={rowsToDisplay}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 160,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={withStealthFlow ? "" : params.row.sapInboundDelivery} 
              item2={params.row.sapOutboundDeliveryOrRSO}
              item3={params.row.isUrgent ? intl.formatMessage({ id: "RASearch.IsUrgent" }) : ""}
              isHighlight={true}
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "customerDescription",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "General.ClientDescription" })}
            item2={intl.formatMessage({ id: "RA.SAPClient" })}
            item2Color={columnColor}
            item3={intl.formatMessage({ id: "RA.STEALTHClient" })}
            rowsToDisplay={rowsToDisplay}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={params.row.customerDescription}
              item2={withStealthFlow ? "" : params.row.customerCode}
              item3={
                params.row.shopCodeSTEALTH != null
                  ? params.row.shopCodeSTEALTH
                  : params.row.customerCodeSTEALTH
              }
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "sapSender",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RASearch.SAPSender" })}
            item1Color={columnColor}
            item2={intl.formatMessage({ id: "RASearch.JDASender" })}
            item3={intl.formatMessage({ id: "RASearch.SenderDescription" })}
            rowsToDisplay={rowsToDisplay}
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={withStealthFlow ? "" : params.row.shopCode}
              item2={params.row.jdaLocation}
              item3={params.row.shopDescription}
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
      {
        field: "destination",
        renderHeader: () => (
          <CustomGridHeaderCell
            item1={intl.formatMessage({ id: "RASearch.SAPDestination" })}
            item1Color={columnColor}
            item2={intl.formatMessage({
              id: "RASearch.JDADestination",
            })}
            item3={intl.formatMessage({
              id: "RASearch.PurchaseOrder",
            })}         
            rowsToDisplay={rowsToDisplay}   
          />
        ),
        headerClassName: "grid-header apeLigthBlueBackground",
        flex: 1,
        minWidth: 200,
        renderCell: (params) => {
          return (
            <CustomGridCell
              item1={withStealthFlow ? "" : params.row.sapSite}
              item2={params.row.jdaLocationDestination}
              item3={params.row.purchaseOrder}
              rowsToDisplay={rowsToDisplay}
            />
          );
        },
      },
    ]);
  };

  const getCountries = async () => {
      setLoading(true);
      apiService.getCountries(
        (response) => {
          setLoading(false);
          var countrySelectItems = [];
          if (response !== undefined) {
            response.map((x) => {
              countrySelectItems.push({
                value: x.idCountry,
                text: x.countryDescription,
              });
            });
        }
        setCountries(countrySelectItems);
        },
        (error) => {
          setLoading(false);
          handleError(error, intl);
        }
      );
    };

  useEffect(() => {
    getCountries();
  }, []);

  const getDepartments = async () => {
    setLoading(true);
    apiService.getDepartments(
      (response) => {
        setLoading(false);
        var selectDepartmentItems = [];
        if (response !== undefined) {
          response.map((x) => {
            selectDepartmentItems.push({
              value: x.departmentCode,
              text: x.departmentCode + " - " + x.departmentName,
            });
          });
        }
        setDepartments(selectDepartmentItems);
      },
      (error) => {
        setLoading(false);
        handleError(error, intl);
      }
    );
  };

  useEffect(() => {
    getDepartments();
  }, []);

  const getTypes = async () => {
    setLoading(true);
    axios
      .get("/masterdata/ReturnFileTypes")
      .then((response) => {
        setLoading(false);
        var selectTypeItems = [];
        if (response.data !== undefined) {
          response.data
            .sort((a, b) =>
              a.returnDescription > b.returnDescription ? 1 : -1
            )
            .map((x) => {
              selectTypeItems.push({
                value: x.idReturnType,
                text: x.returnDescription,
              });
            });
        }
        setTypes(selectTypeItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    getTypes();
  }, []);

  const getStates = async () => {
    setLoading(true);
    axios
      .get("/masterdata/ReturnFileStates")
      .then((response) => {
        setLoading(false);
        var selectItems = [];
        if (response.data !== undefined) {
          response.data.map((x) => {
            selectItems.push({
              value: x.idRFState,
              text: x.rfStateDescription,
            });
          });
        }
        setStates(selectItems);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  useEffect(() => {
    getStates();
  }, []);

  const handleSetInMemorySearchFilters = () => {
    if(searchFilterSlice == null) {
     return;
    }

      const obj = JSON.parse(searchFilterSlice);
      if(obj.RFYear != undefined){
        setYear(obj.RFYear);
      }      
      if(obj.ReturnFileKey != undefined){
        setReturnAuthorizationKey(obj.ReturnFileKey);
      }
      if(obj.BoxBarcode != undefined){
        setBoxBarcode(obj.BoxBarcode);
      }
      if(obj.SKU != undefined){
        setSKU(obj.SKU);
      }
      if(obj.QCCarton != undefined){
        setCartonQC(obj.QCCarton);
      }
      if(obj.Department != undefined){
        var dept = departments.find((x) => x.value == obj.Department);
        setRaDepartment({ text: dept.text, value: dept.value });
      }
      if(obj.IdCountry != undefined){
        var country = countries.find((x) => x.value == obj.IdCountry);
        setCountry({ text: country.text, value: country.value });
      }
      if(obj.IdRFStateList != undefined){
        var state = states.find((x) => x.value == obj.IdRFStateList);
        setState({ text: state.text, value: state.value });
      }
      if(obj.RFNumber != undefined){
        setRaNumber(obj.RFNumber);
      }
      if(obj.RFSplit != undefined){
        setRaSplit(obj.RFSplit);
      }
      if(obj.ICTReference != undefined){
        setJdaIct(obj.ICTReference);
      }
      if(obj.Outcome != undefined){
        setOutcome(obj.Outcome);
      }
      if(obj.SAPRSO != undefined){
        setSapRso(obj.SAPRSO);
      }
      if(obj.SAPInboundDelivery != undefined){
        setSapInboundDelivery(obj.SAPInboundDelivery);
      }
      if(obj.SAPOutboundDelivery != undefined){
        setSapOutboundDelivery(obj.SAPOutboundDelivery);
      }
      if(obj.PurchaseOrder != undefined){
        setPurchaseOrder(obj.PurchaseOrder);
      }
      if(obj.InvoiceNumber != undefined){
        setInvoice(obj.InvoiceNumber);
      }
      if(obj.DossierAge != undefined){
        handleDossierAgeChange(obj.DossierAge);
        if(obj.DossierAge == "Red"){
          handleCheckRadioRed();
        }
        else if(obj.DossierAge == "Orange"){
          handleCheckRadioOrange();
        }
        else if(obj.DossierAge == "Blue"){
          handleCheckRadioWhite();
        }
      }
      if(obj.CustomerCode != undefined){
        if(withStealthFlow){
          setStealthClient(obj.CustomerCode);
        }
        else{
          setSapClient(obj.CustomerCode);
        }
        
      }
      if(obj.CustomerOrShopDescr != undefined){
        setClientDescription(obj.CustomerOrShopDescr);
      }
      if(obj.StealthClientOrShopCode != undefined){
        setStealthClient(obj.StealthClientOrShopCode);
      }
      if(obj.JdaLocation != undefined){
        setJdaLocation(obj.JdaLocation);
      }
      if(obj.ShopCode != undefined){
        setShopCode(obj.ShopCode);
      }
      if(fromDateFilterSlice != undefined){
        setFromDate(fromDateFilterSlice);
      }
      if(toDateFilterSlice != undefined){
        setToDate(toDateFilterSlice);
      }
      if(obj.isUrgent != undefined){
        let isTrue = obj.isUrgent == "true";
        handleIsUrgentChange(isTrue);
      }
      if(obj.IncludeDeleted != undefined){
        let isTrue = obj.IncludeDeleted == "true";
        setIncludeDeleted(isTrue);
      }

      handleSearch();
      dispatch(setDoSearch({doSearch: false}));
    }


  useEffect(() => {
    {
      if(doSearch && departments.length > 0 && countries.length > 0 && states.length > 0){
        handleSetInMemorySearchFilters();
      }
    }
  }, [doSearch, departments, countries, states]);

  const handleSearchClick = () => {
    page.current = 0;
    handleSearch();
  };

  //TODO gestisci parametri con metodi nel serviceBase
  const handleSearch = () => {
    setShouldFilterCollapse(false);
    setLoading(true);
    const params = new URLSearchParams([]);

    params.append("IdCompany", idCompany);
    if (returnAuthorizationKey !== "") {
      params.append("ReturnFileKey", `${returnAuthorizationKey}`);
    }
    if (cartonBarcode !== "") {
      params.append("BoxBarcode", `${cartonBarcode}`);
    }
    if (sku !== "") {
      params.append("SKU", `${sku}`);
    }
    if (cartonQC !== "") {
      params.append("QCCarton", `${cartonQC}`);
    }
    if (year !== undefined) {
      params.append("RFYear", `${year}`);
    }
    if (
      raDepartment != null &&
      raDepartment.text !== undefined &&
      raDepartment.text !== ""
    ) {
      params.append("Department", `${raDepartment.value}`);
    }
    if (raNumber !== undefined && raNumber !== "") {
      params.append("RFNumber", `${raNumber}`);
    }
    if (raSplit !== undefined && raSplit !== "") {
      params.append("RFSplit", `${raSplit}`);
    }

    if (jdaIct !== undefined && jdaIct !== "") {
      params.append("ICTReference", `${jdaIct}`);
    }
    if (outcome !== undefined && outcome !== "") {
      params.append("Outcome", `${outcome}`);
    }
    if (sapRso !== undefined && sapRso !== "") {
      params.append("SAPRSO", `${sapRso}`);
    }
    if (
      sapInboundDelivery !== undefined &&
      sapInboundDelivery !== ""
    ) {
      params.append(
        "SAPInboundDelivery",
        `${sapInboundDelivery}`
      );
    }
    if (
      sapOutboundDelivery !== undefined &&
      sapOutboundDelivery !== ""
    ) {
      params.append(
        "SAPOutboundDelivery",
        `${sapOutboundDelivery}`
      );
    }
    if (
      purchaseOrder !== undefined &&
      purchaseOrder !== ""
    ) {
      params.append("PurchaseOrder", `${purchaseOrder}`);
    }
    if (invoice !== undefined && invoice !== "") {
      params.append("InvoiceNumber", `${invoice}`);
    }
    if (dossierAge !== undefined && dossierAge !== "") {
      params.append("DossierAge", `${dossierAge}`);
    }

    if (
      actAsCustomerCode !== undefined &&
      actAsCustomerCode !== "" &&
      actAsCustomerCode !== null
    ) {
      params.append("CustomerCode", `${actAsCustomerCode}`);
    } else if (
      sapClient !== undefined &&
      sapClient !== "" &&
      customerCode != null
    ) {
      params.append("CustomerCode", `${sapClient}`);
    }

    if (
      clientDescription !== undefined &&
      clientDescription !== ""
    ) {
      params.append(
        "CustomerOrShopDescr",
        `${clientDescription}`
      );
    }

    if (
      stealthClient !== undefined &&
      stealthClient !== "" &&
      stealthClient !== null
    ) {
      params.append(
        "StealthClientOrShopCode",
        stealthClient
      );
    }

    if (country != null && country.text !== undefined && country.text !== "") {
      params.append("IdCountry", `${country.value}`);
    }

    if (state != null && state.text !== undefined && state.text !== "") {
      params.append("IdRFStateList", `${state.value}`);
    }
    if (type !== undefined && type !== "") {
      params.append("IdRFType", `${type}`);
    }

    if (
      jdaLocation !== undefined &&
      jdaLocation !== ""
    ) {
      params.append("JdaLocation", `${jdaLocation}`);
    }

    if (shopCode !== undefined && shopCode !== "") {
      params.append("ShopCode", `${shopCode}`);
    }

    if (fromDate !== undefined && fromDate !== "" && fromDate !== null) {
      var date = fromDate.toISOString().substring(0, 10);
      params.append("FromDate", date);
    }

    if (toDate !== undefined && toDate !== "" && toDate !== null) {
      var date = toDate.toISOString().substring(0, 10);
      params.append("ToDate", date);
    }

    if (isUrgent !== null) {
      params.append("isUrgent", isUrgent ? "true" : "false"); //TODO: da guardare
    }

    if (page.current === 0) {
      page.current = 1;
    }
    params.append("IncludeDeleted", `${includeDeleted}`);
    params.append("PagingInfo.Skip", `${rowsForPage * (page.current - 1)}`);
    params.append("PagingInfo.Take", `${rowsForPage}`);

    handleSaveSearchFilters(
      JSON.stringify(Object.fromEntries(params)),
      fromDate,
      toDate
    );

    axios
      .get("/returnfiles/search", { params })
      .then((response) => {
        setShouldFilterCollapse(true);
        setLoading(false);
        resizeTable();
        setRows(response.data.paginatedItems);
        setTotalCount(response.data.totalCount);
        maxPage.current = Math.ceil(response.data.totalCount / rowsForPage);
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleReset = () => {
    setReturnAuthorizationKey("");
    setCartonBarcode("");
    setYear("");
    setRaDepartment({ text: "", value: "" });
    setRaNumber("");
    setRaSplit("");
    setFromDate(null);
    setToDate(null);
    setType("");
    setState({ text: "", value: "" });
    setSKU("");
    setCartonQC("");
    handleRadioReset();
    setIsUrgent(null);
    setOutcome("");

    setJdaIct("");
    setSapInboundDelivery("");
    setInvoice("");
    setSapRso("");
    setPurchaseOrder("");
    setSapOutboundDelivery("");
    if (
      actAsCustomerCode == null ||
      actAsCustomerCode == undefined ||
      actAsCustomerCode == ""
    ) {
      setSapClient("");
      setStealthClient("");
    }

    setClientDescription("");
    setCountry({ text: "", value: null });
    setJdaLocation("");
    setShopCode("");
    setIncludeDeleted(false);

    handleSaveSearchFilters(null);
  };

  const handleNextPage = () => {
    if (page.current < maxPage.current) {
      page.current = page.current + 1;
      handleSearch();
    }
  };

  const handlePreviousPage = () => {
    if (page.current > 1) {
      page.current = page.current - 1;
      handleSearch();
    }
  };

  const handletrasitionEnd = () => {
    resizeTable();
  };

  const handleRaKeyChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setReturnAuthorizationKey(barcode);
    }
  };

  const handleCartonBarcodeChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setCartonBarcode(barcode);
    }
  };

  const handleDossierAgeChange = (dossierAge) => {
    if (dossierAge !== undefined && dossierAge !== "") {
      setDossierAge(dossierAge);
    } else {
      setDossierAge("");
    }
  };

    const handleIsUrgentChange = (isUrgent) => {
        if (isUrgent !== undefined) {
            setIsUrgent(isUrgent);
        } else {
            setIsUrgent(null);
        }
    };

  const handleSKUChange = (sku) => {
    if (sku.includes("<") || sku.includes(">")) {
      return;
    }
    if (sku !== undefined && sku !== "") {
      setSKU(sku);
    } else {
      setSKU("");
    }
  };

  const handleCartonQCChange = (cartonQC) => {
    if (cartonQC.includes("<") || cartonQC.includes(">")) {
      return;
    }
    if (cartonQC !== undefined && cartonQC !== "") {
      setCartonQC(cartonQC);
    } else {
      setCartonQC("");
    }
  };

  const handleYearChange = (year) => {
    if (year !== undefined && year !== "") {
      setYear(year);
    } else {
      setYear("");
    }
  };

  const handleSaveSearchFilters = (json, fromDateFilter, toDateFilter) => {
    if (doSearch != undefined) {
      dispatch(setSearch({ searchFilters: json }));
      dispatch(setFromDateFilter({ fromDateFilter: fromDateFilter }));
      dispatch(setToDateFilter({ toDateFilter: toDateFilter }));
    }
  };

  const handleInvoiceChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setInvoice(barcode);
    }
  };

  const handleInboundDeliveryChange = (barcode) => {
    if (barcode.includes("<") || barcode.includes(">")) {
      return;
    } else {
      setSapInboundDelivery(barcode);
    }
  };

  return (
    <Box sx={{ overflow: "hidden" }}>
      <PageHeader
        title={intl.formatMessage({
          id: "RASearch.Title",
        })}
      />
      <PageForm
        adjustHeightFunc={handletrasitionEnd}
        shouldCollapse={shouldFilterCollapse}
        form={
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Grid container>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      id="raKeyId"
                      name="RAKey"
                      labelText={intl.formatMessage({ id: "RA.Key" })}
                      type="text"
                      value={returnAuthorizationKey}
                      setValue={(e) => handleRaKeyChange(e)}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      id="cartonBarcodeId"
                      name="CartonBarcode"
                      labelText={intl.formatMessage({
                        id: "RASearch.CartonBarcode",
                      })}
                      type="text"
                      value={cartonBarcode}
                      setValue={(e) => {
                        handleCartonBarcodeChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      id="skuId"
                      name="SKU"
                      labelText={intl.formatMessage({
                        id: "RASearch.SKU",
                      })}
                      type="text"
                      value={sku}
                      setValue={(e) => {
                        handleSKUChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      id="cartonQCId"
                      name="cartonQC"
                      labelText={intl.formatMessage({
                        id: "RASearch.CartonQC",
                      })}
                      type="text"
                      value={cartonQC}
                      setValue={(e) => {
                        handleCartonQCChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                  <Grid item md={6} xs={12} >
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RASearch.Outcome" })}
                      type="text"
                      value={outcome}
                      setValue={setOutcome}
                      textCol={2}
                      inputCol={10}
                    />
                  </Grid>
                  <Grid item md={9.6} xs={8}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Year" })}
                      type="number"
                      value={year}
                      setValue={(e) => {
                        handleYearChange(e);
                      }}
                      textCol={3.8}
                      inputCol={8.2}
                    />
                  </Grid>
                  <Grid item md={1.2} xs={2}>
                    <Button
                      value={new Date().getFullYear() - 1}
                      onClick={(e) => {
                        handleYearChange(e.target.value);
                      }}
                      disableRipple={true}
                      sx={{ marginTop: "10px", width: "100%", minWidth: 0, px: 0.5 }}
                    >
                      {new Date().getFullYear() - 1}
                    </Button>
                  </Grid>
                  <Grid item md={1.2} xs={2}>
                    <Button
                      value={new Date().getFullYear()}
                      onClick={(e) => {
                        handleYearChange(e.target.value);
                      }}
                      disableRipple={true}
                      sx={{ marginTop: "10px", width: "100%", minWidth: 0, px: 0.5 }}
                    >
                      {new Date().getFullYear()}
                    </Button>
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Department" })}
                      type="autocomplete"
                      value={raDepartment}
                      selectItems={departments}
                      setValue={setRaDepartment}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Number" })}
                      type="number"
                      value={raNumber}
                      setValue={setRaNumber}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.Split" })}
                      type="number"
                      value={raSplit}
                      setValue={setRaSplit}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.State" })}
                      type="autocomplete"
                      value={state}
                      selectItems={states}
                      setValue={setState}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item md={6} xs={12}>
                <Grid container>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "RA.ICT" })}
                      type="text"
                      value={jdaIct}
                      setValue={setJdaIct}
                      textCol={3}
                      inputCol={9}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      id="invoiceId"
                      name="invoice"
                      labelText={intl.formatMessage({
                        id: "RA.Invoice",
                      })}
                      type="text"
                      value={invoice}
                      setValue={(e) => {
                        handleInvoiceChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={5}
                      inputCol={7}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      id="setSapInboundDeliveryId"
                      name="setSapInboundDelivery"
                      labelText={intl.formatMessage({
                        id: "RA.SapInboundDelivery",
                      })}
                      type="text"
                      value={sapInboundDelivery}
                      setValue={(e) => {
                        handleInboundDeliveryChange(e);
                      }}
                      iconComponent={BarcodeIcon}
                      textCol={5}
                      inputCol={7}
                      classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                      disabled={withStealthFlow}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.SapOutboundDelivery",
                      })}
                      type="text"
                      value={sapOutboundDelivery}
                      setValue={setSapOutboundDelivery}
                      textCol={7.5}
                      inputCol={4.5}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.SAPRSO",
                      })}
                      type="text"
                      value={sapRso}
                      setValue={setSapRso}
                      textCol={3}
                      inputCol={9}
                      classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                      disabled={withStealthFlow}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.PurchaseOrder",
                      })}
                      type="text"
                      value={purchaseOrder}
                      setValue={setPurchaseOrder}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.SapClientCode",
                      })}
                      type="text"
                      value={sapClient}
                      setValue={setSapClient}
                      defaultValue={withStealthFlow ? null : actAsCustomerCode}
                      disabled={actAsCustomerCode != null || withStealthFlow}
                      textCol={5.5}
                      inputCol={6.5}
                      classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.StealthClientCode",
                      })}
                      type="text"
                      value={stealthClient}
                      setValue={setStealthClient}
                      defaultValue={withStealthFlow ? actAsCustomerCode : null}
                      disabled={actAsCustomerCode != null}
                      textCol={7}
                      inputCol={5}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "General.ClientDescription",
                      })}
                      type="text"
                      value={clientDescription}
                      setValue={setClientDescription}
                      textCol={1.5}
                      inputCol={10.5}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.SAPLocation",
                      })}
                      type="text"
                      value={shopCode}
                      setValue={setShopCode}
                      textCol={3}
                      inputCol={9}
                      classLabel={withStealthFlow ? "apeDisabledColor" : ""}
                      disabled={withStealthFlow}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.JdaLocation",
                      })}
                      type="text"
                      value={jdaLocation}
                      setValue={setJdaLocation}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={12} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({ id: "General.Country" })}
                      type="autocomplete"
                      value={country}
                      selectItems={countries}
                      setValue={setCountry}
                      textCol={1.5}
                      inputCol={10.5}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.FromDate",
                      })}
                      type="date"
                      valueRef={fromDate}
                      setValue={setFromDate}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.ToDate",
                      })}
                      type="date"
                      valueRef={toDate}
                      setValue={setToDate}
                      textCol={4}
                      inputCol={8}
                    />
                  </Grid>
                  <Grid item md={3} xs={12}>
                    <CustomTriStateCheckbox
                      labelText={intl.formatMessage({
                        id: "RASearch.IsUrgent",
                      })}
                      setValue={(e) => {
                        handleIsUrgentChange(e);
                      }}
                      value={isUrgent}
                      valueRef={isUrgent}
                      textCol={5}
                      inputCol={7}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomRadioButton
                      labelText={intl.formatMessage({
                        id: "RASearch.DossierAge",
                      })}
                      setValue={(e) => {
                        handleDossierAgeChange(e);
                      }}
                      valueRef={dossierAge}
                      textCol={5}
                      inputCol={7}
                      onClickRedButton={handleCheckRadioRed}
                      onClickOrangeButton={handleCheckRadioOrange}
                      onClickWhiteButton={handleCheckRadioWhite}
                      checkRadioRed={checkRadioRed}
                      checkRadioOrange={checkRadioOrange}
                      checkRadioWhite={checkRadioWhite}
                    />
                  </Grid>
                  <Grid item md={6} xs={12}>
                    <CustomInput
                      labelText={intl.formatMessage({
                        id: "RASearch.IncludeDeleted",
                      })}
                      type="switch"
                      valueRef={includeDeleted}
                      setValue={setIncludeDeleted}
                      textCol={6}
                      inputCol={6}
                    />
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={6} md={2} display="flex" justifyContent="flex-start">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleReset}
                >
                  {intl.formatMessage({ id: "General.Reset" })}
                </Button>
              </Grid>
              <Grid item xs={false} md={8} sx={{ display: { xs: "none", md: "block" } }} />
              <Grid item xs={6} md={2} display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  sx={{ width: "100%" }}
                  className="apeLigthBlueBackground"
                  onClick={handleSearchClick}
                >
                  {intl.formatMessage({ id: "General.Search" })}
                </Button>
              </Grid>
            </Grid>
          </form>
        }
      />
      <CustomTablePagingInfo
        totalCount={totalCount}
        page={page.current}
        maxPage={maxPage.current}
        handlePreviousPage={handlePreviousPage}
        handleNextPage={handleNextPage}
        rowsToDisplay={handleRowsToDisplay}
        isSearchTable={true}
      />
      <CustomTable
        columns={columns}
        rows={rows}
        id={"idReturnFileHead"}
        rowHeight={rowHeight}
        headerHeight={headerHeight}
        tableHeight={tableHeigth}
        rowsToDisplay={rowsToDisplay}
      />
    </Box>
  );
};


export default RASearch;
